import React from 'react';
import {
  BasicFormModalLayout,
  RemoveStandardAreaInstallationForm
} from 'modules';

export type RemoveStandardAreaInstallationModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: RemoveStandardAreaInstallationModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Remove Template Selection'
      subTitle='Remove this autogenerated selection.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <RemoveStandardAreaInstallationForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
